import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { translate } from '@fiverr-private/i18n-react';

export const FAQTitle = () => (
    <Typography size={{ default: 'h_sm', lg: 'h_md' }} fontWeight="bold" color="grey_1200">
        {translate('seller_page_perseus.professions_page.main_content.faq.title')}
    </Typography>
);
